import React from 'react';

const NavbarSpacer = () => <div className="h-16" />;

export default NavbarSpacer;
